import { render, staticRenderFns } from "./addzian.vue?vue&type=template&id=0c7b7132&scoped=true&"
import script from "./addzian.vue?vue&type=script&lang=js&"
export * from "./addzian.vue?vue&type=script&lang=js&"
import style0 from "./addzian.vue?vue&type=style&index=0&id=0c7b7132&prod&lang=css&"
import style1 from "./addzian.vue?vue&type=style&index=1&id=0c7b7132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b7132",
  null
  
)

export default component.exports